export const tr = {
    'experiments-archive-message-multiply':
        '{experimentsList} Yandex.Audience arşivine taşındı. Arşivlenmiş denemeleri aktif denemeler listesinden çıkarın.',
    'experiments-archive-message-single':
        '{experimentsList} Yandex.Audience arşivine taşındı. Arşivlenmiş denemeyi aktif denemeler listesinden çıkarın.',
    'show-only-selected': 'Sadece seçilenleri göster',
    subtitle: 'Bir kampanya için en fazla 5 adet deneme belirtebilirsiniz',
    title: 'Deneme ayarları'
};
